
<div class="row">
    <div class="col-md-12">
        <div class="u-pb20 u-mb50">
            <div class="row">
                <div class="col-md-8">
                    <p class="txt txt--paragraph u-mb10">
                        <strong>  {{title}} </strong>
                    </p>
                    <p class="txt txt--paragraph u-mb20">
                       {{subTitle}}
                    </p>
                </div>
                <div class="col-md-4 u-right u-mb20">
                    <button class="btn btn--primary" (click)="onShowFormNewAddList()"> {{buttonText}} </button>
                </div>
                <div class="col-md-4" *ngIf="!gettingDropDownElements  && gettingDropDownElementsError === 'DEFAULT_VALUE'">
                    <div class="form autocomplete autocomplete--small">
                        <input type="text" id="iexample" class="form__search" placeholder="Buscar" (keyup)="onKey($event)">
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-md-12">
                    <div class="u-listscroll u-mt50 u-bb u-bb--grey">
                        <div class="loader-element-list" *ngIf="gettingDropDownElements">
                            <app-loader></app-loader>
                        </div>
                        <div class="row">
                            <p *ngIf="!gettingDropDownElements && gettingDropDownElementsError !== 'DEFAULT_VALUE' "> {{gettingDropDownElementsError}} </p>
                            <p *ngIf="!gettingDropDownElements && gettingDropDownElementsError === 'DEFAULT_VALUE' && elementList.length === 0 ">Mensaje provisorio en caso de que no exista nada que mostrar, arreglo vacío.</p>
                            
                            <div class="col-md-6">
                                <ul>
                                    <li *ngFor="let item of elementList | filterArray: searchValue | slice: 0 :elementsPerColumn">
                                        <a  class="txt txt--paragraph" id="item.id" (click)="onShowFormEditList()">
                                            {{item.name}}
                                        </a>
                                    </li>
                                </ul>
                            </div>
                            <div class="col-md-6">
                                <ul>
                                    <li *ngFor="let item of elementList | filterArray: searchValue | slice : elementsPerColumn: elementList.length" >
                                        <a  class="txt txt--paragraph" id="item.id" (click)="onShowFormEditList()">
                                            {{item.name}}
                                        </a>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
